import React, {useEffect, useState} from "react";
import "./../../utils/Style/pages/Banktransfers.scss";
import useCommonAPI from "../../api/CommonAPI";
import {useOutletContext} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import BlurLoading from "../../components/BlurLoading";

function SendBulkRequest() {
    const {getAllCurrencies, currencies} = useCommonAPI();

    const [onOpenQrAfterGenerate] = useOutletContext();
    const dispatch = useDispatch();

    const [selectedFile, setSelectedFile] = useState(new File([], ""));
    const [payload, setPayload] = useState({
        DaysToExpire: "",
        ReasonFileName: "",
        formFile: null,
    });
    const [errors, setErrors] = useState({});


    useEffect(() => {
        if (selectedFile) {
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onloadend = () => {
                const base64String = reader.result;
                setPayload((prevState) => ({
                    ...prevState,
                    ReasonFileName: selectedFile.name,
                    formFile: base64String
                }));
            };

        }
    }, [selectedFile]);

    const handleChange = (event) => {
        const {name, value} = event.target;
        setPayload({...payload, [name]: value});
        setErrors({...errors, [name]: ""});
    };


    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!payload.DaysToExpire) {
            newErrors.DaysToExpire = "Expiry Days is required.";
            isValid = false;
        }
        if (selectedFile === undefined || selectedFile.name === undefined || selectedFile.size <= 0) {
            newErrors.ReasonFile = "File upload is required.";
            isValid = false;
        } else if (!/\.xlsx?$/.test(selectedFile.name.toLowerCase())) {
            newErrors.ReasonFile = "Only Excel files are allowed.";
            isValid = false;
        }

        const fileSizeLimit = 2 * 1024 * 1024; // 2 MB
        if (selectedFile && selectedFile.size > fileSizeLimit){
            newErrors.ReasonFile = "File should not be larger than 2MB.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (validateForm()) {
            dispatch(setActionType(ACTION_TYPES.INITIATE_BULK_PAYMENT_REQUEST));
            dispatch(setActionPayload(payload));

            onOpenQrAfterGenerate();
        }
    };
    return (
        <>
            <div className="NewTransferTemplate">
                {<BlurLoading/>}

                <div className="title">Request money from 2 & more users</div>
                <form className="NewTransferTemplate" onSubmit={handleSubmit} autoComplete="off">
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Payment Request will expire in (days)</div>
                        <div className="col-lg-6 col-md-7">
                            <input
                                type="number"
                                name="DaysToExpire"
                                value={payload.ExpiryDays}
                                onChange={handleChange}
                            />
                            {errors.DaysToExpire && (
                                <span className="error">{errors.DaysToExpire}</span>
                            )}
                        </div>
                    </div>
                    <div className="title">Recipients Information (Download <a className="clickable-file"
                                                                                  href={sessionStorage.getItem("PaymentRequestTemplate")}>.CSV
                        sample file</a>)
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Upload File</div>
                        <div className="col-lg-6 col-md-7">
                            <input
                                type="file"
                                id="myFile"
                                name="ReasonFile"
                                className="placeholder-color"
                                onClick={
                                    (e) => {
                                        e.target.value = null;
                                        setErrors({...errors, ReasonFile: ""});
                                    }
                                }
                                onChange={
                                    (e) => {
                                        setSelectedFile(e.target.files[0])
                                    }
                                }/>
                            {errors.ReasonFile && (
                                <span className="error">{errors.ReasonFile}</span>
                            )}
                        </div>
                    </div>
                    <div className="row submitForm">
                        <div className="col-9 btn_place">
                            <button type="submit" className="submitBtn">Confirm</button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default SendBulkRequest;